var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120870",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "#767676",
    stroke: "#767676"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pause",
    transform: "translate(-1, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120864",
    x: -0.5,
    y: 0.5,
    width: 4,
    height: 17,
    transform: "matrix(-1 0 0 1 22 16)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120865",
    x: -0.5,
    y: 0.5,
    width: 4,
    height: 17,
    transform: "matrix(-1 0 0 1 33 16)",
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButtonIcon);
export default __webpack_public_path__ + "static/media/PauseButtonIcon.4530e0bd9faae244795aea6c6f15031f.svg";
export { ForwardRef as ReactComponent };